import { validate as uuidValidate } from 'uuid';
import GeckoLocation from '../../services/gecko-location';
import { CONSTS } from 'constants/index.js';
const DEFAULT_FILTER = CONSTS.FILTER_MY_CONVERSATIONS;

const getFilterParam = () => {
  if (GeckoLocation.params?.filter) {
    return GeckoLocation.params.filter;
  }
  return DEFAULT_FILTER;
};

const filterMap = {
  [CONSTS.FILTER_MY_CONVERSATIONS]: 'myConversations',
  [CONSTS.FILTER_UNASSIGNED]: 'unassignedConversations',
  [CONSTS.FILTER_OPEN]: 'openConversations',
  [CONSTS.FILTER_CLOSED]: 'closedConversations',
  [CONSTS.FILTER_SENT]: 'sentConversations',
  [CONSTS.FILTER_ASSIGNED_TO_BOT]: 'botInterferenceConversations',
  [CONSTS.FILTER_CONTACT]: 'allForContactFilter',
  [CONSTS.FILTER_CONTACT_OPEN]: 'contactFilter',
  [CONSTS.FILTER_TAG]: 'tagFilter',
  [CONSTS.FILTER_CUSTOM_FILTER]: 'customFilter',
  [CONSTS.FILTER_UNDELIVERED]: 'undeliveredMessagesConversations',
};

const getConversationRouteFilter = (state) => {
  const filterParam = getFilterParam();
  if (uuidValidate(filterParam)) {
    return state.conversationsRoute.savedCustomFilters.find(
      (customFilter) => customFilter.id === filterParam
    );
  }
  const currentFilter = filterMap[filterParam];
  return state.conversationsRoute[currentFilter];
};

export const getCustomFilterConversations = (state) =>
  state.conversationsRoute.customFilter;

export const getChannels = (state) => state.channels;
export const getCurrentFilter = () => getFilterParam();
export const getFetching = (state) =>
  getConversationRouteFilter(state)?.fetching;
export const getNextPage = (state) =>
  getConversationRouteFilter(state)?.nextPage;
export const getPage = (state) => getConversationRouteFilter(state)?.page;
export const getPerPage = (state) => getConversationRouteFilter(state)?.perPage;
export const getScreenSize = (state) => state.appState.screenSize;
export const getQuickFilter = (state) =>
  getConversationRouteFilter(state)?.quickFilter;
export const getIsQuickFilterApplied = (state) =>
  getQuickFilter(state) !== null;
